module.exports = __webpack_public_path__ + "static/media/try-new-en.6dadd679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/try-new-en.png
// module id = 907
// module chunks = 7